import { render, staticRenderFns } from "./AddStudentByDept.vue?vue&type=template&id=0005a6d3&scoped=true&"
import script from "./AddStudentByDept.vue?vue&type=script&lang=js&"
export * from "./AddStudentByDept.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentByDept.vue?vue&type=style&index=0&id=0005a6d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005a6d3",
  null
  
)

export default component.exports